import Metalpha from '@/assets/image/useCases/digitalAssets/Metalpha.png'
import SBI from '@/assets/image/useCases/digitalAssets/SBI.png'
import Galaxy from '@/assets/image/useCases/digitalAssets/Galaxy.png'
import AnchorageDigital from '@/assets/image/useCases/digitalAssets/AnchorageDigital.png'
import BitGo from '@/assets/image/useCases/digitalAssets/BitGo.png'
import Ceffu from '@/assets/image/useCases/digitalAssets/Ceffu.png'
import Cobo from '@/assets/image/useCases/digitalAssets/Cobo.png'
import ContentImg1 from '@/assets/image/useCases/digitalAssets/content_img1.png'
import ContentImg2 from '@/assets/image/useCases/digitalAssets/content_img2.png'
import ContentImg3 from '@/assets/image/useCases/digitalAssets/content_img3.png'
import ContentImg4 from '@/assets/image/useCases/digitalAssets/content_img4.png'
import './index.scss'
import { useMediaQuery } from 'react-responsive';
const trustList = [
  {
    logo: Metalpha,
  }, {
    logo: SBI,
  }, {
    logo: Galaxy,
  }, {
    logo: AnchorageDigital,
  }, {
    logo: BitGo,
  }, {
    logo: Ceffu,
  }, {
    logo: Cobo,
  }
]

const DigitalAssetsContent = () => {
  const isDesktop = useMediaQuery({ minWidth: 769 });

  return (
    <div className={`digital-assets-list text-[#fff]`}>
      {
        isDesktop?(
          <>
            <div className={`digital-assets-list-item`}>
              <div className={`w-1340 flex items-center trust-wrap digital-assets-list-item-content`}>
                <div className={`trust-title w-[268px] text-[18px] text-center leading-[60px] h-[60px]`}>Trusted by
                </div>
                <div className={`trust-list flex h-[60px] items-center`}>
                  {
                    trustList.map((item, i) => (
                      <div key={i} className={`trust-list-item flex items-center ml-[40px]`}>
                        <img src={item.logo} className={`h-[18px]`} />
                      </div>
                    ))
                  }
                </div>
              </div>
            </div>
            <div className={`digital-assets-list-item`}>
              <div className={`w-1340 flex items-center  digital-assets-list-item-content`}>
                <div style={{ borderRight: '1px solid #434343' }}
                     className={`flex-1 flex justify-center items-center pt-[44px] pb-[44px]`}>
                  <img src={ContentImg1} className={`h-[244px]`} />
                </div>
                <div className={`flex-1 flex justify-center items-center pt-[44px] pb-[44px]`}>
                  <img src={ContentImg2} className={`h-[244px]`} />
                </div>
              </div>
            </div>
            <div className={`digital-assets-list-item`}>
              <div className={`w-1340 flex content-wrap digital-assets-list-item-content`}>
                <div style={{ borderRight: '1px solid #434343' }}
                     className={`flex-1 content-item pt-[40px] pb-[18px] pl-[96px] pr-[102px]`}>
                  <div className={`content-item-title mb-[10px]`}>No Counterparty Exposure</div>
                  <div className={`content-item-desc`}>Keep assets with compliant custodians. Vishwa only use
                    ZK-verified
                    proofs of ownership to execute strategies, so the underlying collateral never leaves custody.
                  </div>
                </div>
                <div className={`flex-1 content-item pt-[40px] pb-[18px] pl-[96px] pr-[102px]`}>
                  <div className={`content-item-title mb-[10px]`}>Trustless Execution</div>
                  <div className={`content-item-desc`}>Fully automated, trustless workflows remove operational drag,
                    messy
                    handoffs, and single points of failure.
                  </div>
                </div>
              </div>
            </div>
            <div className={`digital-assets-list-item`}>
              <div className={`w-1340 flex items-center  digital-assets-list-item-content`}>
                <div style={{ borderRight: '1px solid #434343' }}
                     className={`flex-1 flex justify-center items-center pt-[44px] pb-[44px]`}>
                  <img src={ContentImg3} className={`h-[244px]`} />
                </div>
                <div className={`flex-1 flex justify-center items-center`}>
                  <img src={ContentImg4} className={`h-[244px]`} />
                </div>
              </div>
            </div>
            <div className={`digital-assets-list-item`}>
              <div className={`w-1340 flex content-wrap digital-assets-list-item-content`}>
                <div style={{ borderRight: '1px solid #434343' }}
                     className={`flex-1 content-item pt-[40px] pb-[60px] pl-[96px] pr-[102px]`}>
                  <div className={`content-item-title mb-[10px]`}>Made Productive</div>
                  <div className={`content-item-desc`}>
                    Make BTC productive, safely. BTC is the hardest asset to put to work and it has no native yield, but
                    Vishwa unlocks new liquidity and yield paths on-chain while keeping a self-custody-grade security
                    posture.
                  </div>
                </div>
                <div className={`flex-1 content-item pt-[40px] pb-[60px] pl-[96px] pr-[102px]`}>
                  <div className={`content-item-title mb-[10px]`}>Institution-Ready Compliance</div>
                  <div className={`content-item-desc`}>
                    Assets remain under custody with clear audit trails, and strategies can run without unnecessary sell
                    events that may trigger taxable disposals.
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className={`digital-assets-list-item`}>
              <div className={`w-1340 trust-wrap digital-assets-list-item-content`}>
                <div className={`trust-title text-[18px] text-center leading-[60px] h-[60px]`}>
                  Trusted by
                </div>
                <div className={`trust-list flex flex-wrap items-center justify-around p-[0_20px_20px]`}>
                  {
                    trustList.map((item, i) => (
                      <div key={i} className={`trust-list-item flex items-center m-[10px]`}>
                        <img src={item.logo} className={`h-[18px]`} />
                      </div>
                    ))
                  }
                </div>
              </div>
            </div>
            <div className={`digital-assets-list-item`}>
              <div className={`w-1340 digital-assets-list-item-content`}>
                <div style={{ borderBottom: '1px solid #434343' }}
                     className={`flex-1 flex justify-center items-center p-[20px]`}>
                  <img src={ContentImg1} className={`h-[244px]`} />
                </div>
                <div className={`flex-1 flex justify-center items-center p-[20px]`}>
                  <img src={ContentImg2} className={`h-[244px]`} />
                </div>
              </div>
            </div>
            <div className={`digital-assets-list-item`}>
              <div className={`w-1340 content-wrap digital-assets-list-item-content`}>
                <div style={{ borderBottom: '1px solid #434343' }}
                     className={`flex-1 content-item p-[20px]`}>
                  <div className={`content-item-title mb-[10px]`}>No Counterparty Exposure</div>
                  <div className={`content-item-desc`}>Keep assets with compliant custodians. Vishwa only use
                    ZK-verified
                    proofs of ownership to execute strategies, so the underlying collateral never leaves custody.
                  </div>
                </div>
                <div className={`flex-1 content-item p-[20px]`}>
                  <div className={`content-item-title mb-[10px]`}>Trustless Execution</div>
                  <div className={`content-item-desc`}>Fully automated, trustless workflows remove operational drag,
                    messy
                    handoffs, and single points of failure.
                  </div>
                </div>
              </div>
            </div>
            <div className={`digital-assets-list-item`}>
              <div className={`w-1340 digital-assets-list-item-content`}>
                <div style={{ borderBottom: '1px solid #434343' }}
                     className={`flex justify-center items-center p-[20px]`}>
                  <img src={ContentImg3} className={`h-[244px]`} />
                </div>
                <div className={`flex justify-center items-center p-[20px]`}>
                  <img src={ContentImg4} className={`h-[244px]`} />
                </div>
              </div>
            </div>
            <div className={`digital-assets-list-item`}>
              <div className={`w-1340 content-wrap digital-assets-list-item-content`}>
                <div style={{ borderBottom: '1px solid #434343' }}
                     className={`content-item p-[20px]`}>
                  <div className={`content-item-title mb-[10px]`}>Made Productive</div>
                  <div className={`content-item-desc`}>
                    Make BTC productive, safely. BTC is the hardest asset to put to work and it has no native yield, but
                    Vishwa unlocks new liquidity and yield paths on-chain while keeping a self-custody-grade security
                    posture.
                  </div>
                </div>
                <div className={`content-item p-[20px]`}>
                  <div className={`content-item-title mb-[10px]`}>Institution-Ready Compliance</div>
                  <div className={`content-item-desc`}>
                    Assets remain under custody with clear audit trails, and strategies can run without unnecessary sell
                    events that may trigger taxable disposals.
                  </div>
                </div>
              </div>
            </div>
          </>
        )
      }

    </div>
  )
}

export default DigitalAssetsContent